<template>
    <div class="row m-1 mt-2">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <v-server-table :columns="columns" url="flows" :options="options"></v-server-table>
                           </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
</template>
<style>
    .row [class*='col'] {
    transition: all 0.5s ease-in-out;
}
</style>
<script>
    import axios from 'axios';
    export default {
        components: {
             
        },
        data() {
            return {
                ad: axios.defaults,
                columns: [ 'name'],
                tableData: [],
                options: {
                    requestFunction: function (data) {
                        console.log(data);
                        return axios.get(this.url, {
                           params:data
                        }).catch(function (e) {
                            this.dispatch('error', e);
                        }.bind(this));
                    }

                    , responseAdapter({ data }) {
                        return data;
                    }
                }
            }
        },
        name: 'flowindex',
        beforeMount() {
           
        },
        methods: {
          

        }
    };
</script>
